import React from "react"

const FlightDetailsSkeleton = () => {
  return (
    <div className="w-full p-6 bg-white rounded-lg">
      {/* First row */}
      <div className="flex gap-4 mb-8">
        {/* Avatar */}
        <div className="w-16 h-16 bg-gray-300 rounded-full animate-pulse" />

        {/* Content blocks */}
        <div className="flex-1 space-y-3">
          <div className="flex gap-3">
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
          </div>
          <div className="flex gap-3">
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
          </div>
        </div>

        {/* Right sidebar */}
        <div className="w-40 space-y-3">
          <div className="h-4 bg-gray-300 rounded w-full animate-pulse" />
          <div className="h-4 bg-gray-300 rounded w-full animate-pulse" />
        </div>
      </div>

      {/* Action bar */}
      <div className="flex items-center gap-4 mb-8">
        <div className="h-6 bg-gray-300 rounded w-32 animate-pulse" />
        <div className="ml-auto flex gap-2">
          <div className="w-8 h-8 bg-gray-300 rounded-full animate-pulse" />
          <div className="w-8 h-8 bg-gray-300 rounded-full animate-pulse" />
          <div className="w-8 h-8 bg-gray-300 rounded-full animate-pulse" />
        </div>
      </div>

      {/* Second row */}
      <div className="flex gap-4">
        {/* Avatar */}
        <div className="w-16 h-16 bg-gray-300 rounded-full animate-pulse" />

        {/* Content blocks */}
        <div className="flex-1 space-y-3">
          <div className="flex gap-3">
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
          </div>
          <div className="flex gap-3">
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
            <div className="h-4 bg-gray-300 rounded w-32 animate-pulse" />
          </div>
        </div>

        {/* Right sidebar */}
        <div className="w-40 space-y-3">
          <div className="h-12 bg-gray-300 rounded w-full animate-pulse" />
          <div className="h-4 bg-gray-300 rounded w-full animate-pulse" />
          <div className="h-4 bg-gray-300 rounded w-full animate-pulse" />
        </div>
      </div>

      {/* Action bar */}
      <div className="flex items-center gap-4 mt-4">
        <div className="h-6 bg-gray-300 rounded w-32 animate-pulse" />
        <div className="ml-auto flex gap-2">
          <div className="w-8 h-8 bg-gray-300 rounded-full animate-pulse" />
          <div className="w-8 h-8 bg-gray-300 rounded-full animate-pulse" />
          <div className="w-8 h-8 bg-gray-300 rounded-full animate-pulse" />
        </div>
      </div>
    </div>
  )
}

export default FlightDetailsSkeleton
